var map = {
  "./ca885374-40e3-475a-945e-e6d17b7bf3c3.json": [
    "53918",
    "339"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 17483;
module.exports = __rspack_async_context;
